import React, { FC } from 'react';
import { FallbackProps } from 'react-error-boundary';
import { GenericError } from '~/components/generic-error';

export const AppErrorBoundary: FC<FallbackProps> = ({ error }) => {
  return <GenericError error={error} containerCls="mt-20" />;
};
